import * as React from "react";
import { CheckCircle2, Clock, ClockCheck, Inbox } from "lucide-react";
import { SuperPageAssignment } from "@/services/bedrock/dtos/SuperPage";
import { Tooltip } from "@/components/ui/tooltip";
import moment from "moment";

export function timestampLabel(date: string, verb: string): string {
  const dateMoment = moment(date);
  if (dateMoment.isSame(moment(), "day")) {
    return verb + " at " + dateMoment.format("h:mm a");
  } else if (dateMoment.isBetween(moment().subtract(1, "year"), moment(), undefined, "[]")) {
    return verb + " on " + dateMoment.format("MMM D");
  } else {
    return verb + " on " + dateMoment.format("MMM D, YYYY");
  }
}

export type Props = {
  status: SuperPageAssignment.Status;
  viewedAt?: string | null;
  includeTooltip?: boolean;
  includeLabel?: boolean;
};

const SuperPageAssignmentStatus: React.FC<Props> = ({
  status,
  viewedAt,
  includeTooltip = false,
  includeLabel = false,
}) => {
  var content, tooltipContent, label;
  if (status === "AVAILABLE") {
    content = <Inbox className="size-6 bg-sky-500 stroke-white p-1 rounded-full" />;
    tooltipContent = includeLabel ? undefined : "Available";
    label = "Available";
  } else if (status === "COMPLETED") {
    content = <CheckCircle2 className="size-6 bg-emerald-500 stroke-white p-1 rounded-full" />;
    tooltipContent = includeLabel ? undefined : "Completed";
    label = "Completed";
  } else if (viewedAt) {
    content = <ClockCheck className="size-6 bg-amber-500 stroke-white p-1 rounded-full" />;
    var viewedAtLabel = timestampLabel(viewedAt, "Viewed");
    tooltipContent = includeLabel ? viewedAtLabel : `Requested (${viewedAtLabel})`;
    label = "Requested";
  } else {
    content = <Clock className="size-6 bg-amber-500 stroke-white p-1 rounded-full" />;
    tooltipContent = includeLabel ? undefined : "Requested";
    label = "Requested";
  }

  if (includeLabel) {
    content = (
      <div className="flex items-center gap-2">
        {content}
        {label}
      </div>
    );
  }
  if (includeTooltip && tooltipContent) {
    content = (
      <Tooltip>
        <Tooltip.Trigger render={<span className="inline-flex items-center">{content}</span>} />
        <Tooltip.Content>{tooltipContent}</Tooltip.Content>
      </Tooltip>
    );
  }
  return content;
};

export { SuperPageAssignmentStatus };
